import './index.scss';

import {jump} from '../../tools';
import {inject, observer} from 'mobx-react';

@inject(({store}) => {
    return {
        bannerImgSrc: store.bannerImg,
        topVideo: store.topVideo,
        toggleVideo: store.toggleVideo
    };
})
@observer
class TopVideo extends React.Component {
    render() {
        let {bannerImgSrc, topVideo} = this.props;
        if (!bannerImgSrc?.img?.url && !topVideo?.video) {
            return null;
        }
        return (
            <div className="topVideo">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/title1.jpg"/>
                <div className="video-box" onClick={() => this.props.toggleVideo(topVideo.video)} data-sk-eid="abu_video">
                    <img src={topVideo?.video?.cover?.url}/>
                    <span className="yo-ico btn">&#xe3a8;</span>
                </div>
                <div className="txtBox">
                    {topVideo.desc}
                </div>
                <div className="banner" data-sk-eid="abu_banner" onClick={() => jump(bannerImgSrc?.jumpInfo)}>
                    <img src={bannerImgSrc?.img?.url} />
                </div>
            </div>
        );
    }
}

export default TopVideo;